import script from "./InformationDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./InformationDetail.vue?vue&type=script&setup=true&lang=ts"

import "./InformationDetail.vue?vue&type=style&index=0&id=2cdd5deb&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cdd5deb"]])

export default __exports__